import script from "./CRM01_012INS.vue?vue&type=script&setup=true&lang=js"
export * from "./CRM01_012INS.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__